import React from "react";
import { Link } from "react-router-dom";
import VentasDelDiaSucursal from './CorteSucursal'
const ItemSucursal = ({ sucursal, rol}) =>{

   if(sucursal.nombre === 'Bodega'){
      return <></>;
   }
	
   let total = typeof sucursal.total === undefined ? 0 : sucursal.total;

   return(
		<div className={rol===1?"xs-12 sm-12 md-6 lg-6":"xs-12 sm-12 md-3 lg-3"}>
			<div className="item-suc square-small" style={{marginBottom:'30px',background:'#fff'}}>
            <div className="xs-6 sm-6 md-5 lg-5">
               <span>Total</span><br/>
               <small>{sucursal.nombre}</small> 
               <h3>{window.$fmoney(total,2)}</h3>
               {
                  total>0
                  ?<Link to={"/reportegeneral/"} className="btn btn-green btn-small relative" style={{top:'5px'}}>Reportes</Link>
                  :<div className='btn-lock relative' style={{top:'12px'}}>Reportes</div>
               }
            </div>
            <VentasDelDiaSucursal sucursalid={sucursal.id}/>
			</div>
		</div>
	);
}

const TotalSucursales = (props) => {
   const {sucursales} = props;   
   return (
      <div className="xs-12 sm-12 md-12 lg-12">
         <div className="xs-12 sm-12 md-12 lg-12 text-center">
            <h3 className="pink-color bold">Ventas del día</h3><br />
            <br />
         </div>
         {sucursales.map((e,i)=><ItemSucursal key={i} rol={props.rol} sucursal={e}/>)}
      </div>
   );
};
export default TotalSucursales;
